/* eslint-disable sort-keys */
export const urls: Record<
  'nl',
  Record<string, '/l/nl/nl' | `/l/nl/nl/${string}`>
> = {
  nl: {
    // Home
    '': '/l/nl/nl/home',

    // Alumni
    alumni: '/l/nl/nl/alumni',

    // B2B
    bedrijven: '/l/nl/nl/b2b',
    'bedrijven/contact': '/l/nl/nl/b2b/apply',

    // Blog
    blog: '/l/nl/nl/blog',

    // Campus
    amsterdam: '/l/nl/nl/campus/ams',
    remote: '/l/nl/nl/campus/rmt',

    // Career
    'carriere-coaching': '/l/nl/nl/career',

    // Courses
    'web-development': '/l/nl/nl/course/wd',
    'data-analytics': '/l/nl/nl/course/da',
    'ux-ui-design': '/l/nl/nl/course/ux',
    cybersecurity: '/l/nl/nl/course/cy',

    // FAQ
    faq: '/l/nl/nl/faq',

    // Financing Options
    financiering: '/l/nl/nl/financing',

    // Forms
    aanmelden: '/l/nl/nl/apply',
    aanmelden2: '/l/nl/nl/full-apply',
    contact: '/l/nl/nl/contact',
    'financiering-formulier': '/l/nl/nl/financing-form',
    bedankt: '/l/nl/nl/thank-you',
    bedankt2: '/l/nl/nl/thank-you-dynamic',

    // Syllabus Forms
    'cybersecurity/curriculum': '/l/nl/nl/syllabus/cy',
    'data-analytics/curriculum': '/l/nl/nl/syllabus/da',
    'ux-ui-design/curriculum': '/l/nl/nl/syllabus/ux',
    'web-development/curriculum': '/l/nl/nl/syllabus/wd',
    'data-science-machine-learning/curriculum': '/l/nl/nl/syllabus/ml',
    'kunstmatige-intelligentie/curriculum': '/l/nl/nl/syllabus/ai',
    'devops-cloud-computing/curriculum': '/l/nl/nl/syllabus/dv',
    'digital-marketing/curriculum': '/l/nl/nl/syllabus/mk',

    // Legal Pages
    'privacy-policy': '/l/nl/nl/privacy',
    'terms-of-use': '/l/nl/nl/terms',

    // PDP
    'web-development/amsterdam': '/l/nl/nl/pdp/wd/ams',
    'web-development/remote': '/l/nl/nl/pdp/wd/rmt',
    'data-analytics/amsterdam': '/l/nl/nl/pdp/da/ams',
    'data-analytics/remote': '/l/nl/nl/pdp/da/rmt',
    'ux-ui-design/amsterdam': '/l/nl/nl/pdp/ux/ams',
    'ux-ui-design/remote': '/l/nl/nl/pdp/ux/rmt',
    'cybersecurity/amsterdam': '/l/nl/nl/pdp/cy/ams',
    'cybersecurity/remote': '/l/nl/nl/pdp/cy/rmt',
    'data-science-machine-learning/remote': '/l/nl/nl/pdp/ml/rmt',
    'kunstmatige-intelligentie/remote': '/l/nl/nl/pdp/ai/rmt',
    'devops-cloud-computing/remote': '/l/nl/nl/pdp/dv/rmt',
    'digital-marketing/remote': '/l/nl/nl/pdp/mk/rmt',
  },
};
/* eslint-enable sort-keys */
